import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col pt-5" }
const _hoisted_2 = { class: "justify-center" }
const _hoisted_3 = { class: "mr-2 mb-2 pt-3 pb-3 pr-2 pl-2 flex flex-row items-start relative border-2 border-gray-300 shadow rounded-lg" }
const _hoisted_4 = { class: "flex-col pl-3" }
const _hoisted_5 = { class: "sm:pl-10 md:pl-5 flex-col inline-flex pl-2 overflow-ellipsis" }
const _hoisted_6 = { class: "flex font-bold text-lg text-gray-600 justify-start overflow-ellipsis" }
const _hoisted_7 = { class: "flex font-bold text-gray-400 overflow-ellipsis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_person = _resolveComponent("md-person")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_avatar = _resolveComponent("n-avatar")!
  const _component_n_grid_item = _resolveComponent("n-grid-item")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_grid, { cols: "1 640:2 768:3 1024:3" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.person, (col, index) => {
                    return (_openBlock(), _createBlock(_component_n_grid_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_n_avatar, {
                              round: "",
                              size: "small",
                              style: {
              color: 'white',
              backgroundColor: 'green',
            }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_md_person)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(col.Name), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(col.Email), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}